import { useState } from 'react';

const ContactInfo = () => {




  return (
    <aside className="space-y-8">






      {/* Quick Actions */}
      <div className="card-elevated">
        <div className="p-8">
          <h3 className="text-2xl font-elegant font-bold text-ballet-burgundy mb-6 text-center">
            Quick Actions
          </h3>

          <div className="space-y-4">
            <button className="w-full btn-primary group">
              <svg className="w-5 h-5 mr-2 group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Schedule a Tour
            </button>
            <button className="w-full btn-secondary group">
              <svg className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
              Register for Classes
            </button>
            <button className="w-full bg-ballet-light text-ballet-burgundy px-6 py-4 rounded-xl font-semibold hover:bg-ballet-pink hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 group">
              <svg className="w-5 h-5 mr-2 group-hover:bounce transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              View Calendar
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ContactInfo;
